import { Marketplace } from 'APIs/marketplaces/marketplaces.types';
import { createContext, useContext } from 'react';

export const CreateMarketplaceContext = createContext<
  | {
      marketplaceId: string;
      marketplace: Marketplace | null;
      setMarketplace: (marketplace: Marketplace) => void;
      fetchMarketplace: () => Promise<void>;
    }
  | undefined
>(undefined);

export function useCreateMarketplaceContext() {
  const context = useContext(CreateMarketplaceContext);
  if (context === undefined) {
    throw new Error('useCreateMarketplaceContext must be used with a CreateMarketplaceContext');
  }

  return context;
}
